<template>
	<NoticeDetailPage page-type="auto" :notice-id="noticeId" />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import NoticeDetailPage from '@/components/notice/NoticeDetailPage.vue';

const route = useRoute();
// 旧链接 301 落地页：/notice/{id}.html（对齐 PC），类型由详情数据 noticeType 决定（4=头条，否则质量公告）
const noticeId = computed(() => String(route.params.id ?? '').replace(/\.html$/i, ''));
</script>
